import React, { useState, useEffect } from "react";

export const svg = `<svg width="40" height="40" viewbox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="8" fill="url(#probuild-icon-a)" fill-opacity=".15"></rect><path d="m17.432 17.524-.007-.005c-.21-.172-.478-.265-.825-.265h-1.59a.136.136 0 0 0-.136.136v1.845c0 .075.061.136.137.136h1.59c.35 0 .62-.099.829-.283.204-.19.31-.438.31-.769 0-.405-.118-.65-.308-.795Z" fill="url(#probuild-icon-b)"></path><path d="m25.73 21.047-.007-.007c-.168-.16-.41-.253-.758-.253H23.15a.136.136 0 0 0-.137.136v1.686c0 .075.061.136.137.136h1.803c.392 0 .644-.094.797-.242.153-.147.25-.384.25-.757 0-.33-.099-.55-.268-.7Z" fill="url(#probuild-icon-c)"></path><path d="M23.149 18.868h1.563c.33 0 .555-.075.704-.198.149-.123.236-.306.236-.589 0-.308-.088-.5-.227-.619-.148-.128-.375-.208-.713-.208h-1.563a.136.136 0 0 0-.137.136v1.343c0 .075.061.135.137.135Z" fill="url(#probuild-icon-d)"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M22.02 7.12a4.068 4.068 0 0 0-4.04 0l-8.21 4.704a4.005 4.005 0 0 0-2.02 3.473v9.406c0 1.433.77 2.757 2.02 3.473l8.21 4.703a4.068 4.068 0 0 0 4.04 0l8.21-4.703a4.005 4.005 0 0 0 2.02-3.473v-9.406c0-1.433-.77-2.757-2.02-3.473L22.02 7.12Zm-9.413 17.143v-8.527c0-.33.27-.599.604-.599h3.416c.998 0 1.83.284 2.477.867.651.58.97 1.36.97 2.315 0 .954-.309 1.733-.941 2.313-.623.58-1.468.856-2.506.856h-1.616a.136.136 0 0 0-.137.136v2.64a.6.6 0 0 1-.604.598h-1.06a.601.601 0 0 1-.603-.599Zm14.775-.235-.003.003c-.606.573-1.574.831-2.84.831h-3.19a.601.601 0 0 1-.604-.599v-8.527c0-.33.27-.599.604-.599h3.59c.874 0 1.599.258 2.148.793a2.55 2.55 0 0 1 .832 1.926c0 .726-.273 1.311-.808 1.74.287.179.529.416.727.71.288.405.427.89.427 1.44 0 .933-.288 1.702-.883 2.282Z" fill="url(#probuild-icon-e)"></path><defs><linearGradient id="probuild-icon-a" x1="0" y1="40" x2="40" y2="0" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="probuild-icon-b" x1="7.75" y1="33.417" x2="34.473" y2="9.018" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="probuild-icon-c" x1="7.75" y1="33.417" x2="34.473" y2="9.018" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="probuild-icon-d" x1="7.75" y1="33.417" x2="34.473" y2="9.018" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient><linearGradient id="probuild-icon-e" x1="7.75" y1="33.417" x2="34.473" y2="9.018" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
